<template>
  <Modal
    title="Create URL Widget"
    okButtonLabel="Create"
    :modalStyles="{ width: '500px' }"
    :okFunction="createLinkWidget"
    :disabled="disableOkButton"
    @close="$emit('closeModal')"
    @closeModal="closeModal"
  >
    <template #body>
      <div class="group-body">
        <div class="form-group">
          <label class="label" for="widgetName">
            <div class="label-text">Widget Name</div>
            <input
              type="text"
              name="widgetName"
              id="widgetName"
              v-model="name"
              placeholder="Set widget's name"
              maxlength="40"
            />
          </label>
        </div>

        <div class="form-group">
          <label class="label" for="linkUrl">
            <div class="label-text">URL</div>
            <input
              type="text"
              name="linkUrl"
              id="linkUrl"
              v-model="link"
              autocomplete="on"
              placeholder="https://example.com"
              :class="{ 'is-invalid': linkUsed && !isValidUrl }"
              @blur="linkUsed = true"
            />
            <div class="invalid-feedback" v-if="linkUsed && !isValidUrl">
              Please enter a valid URL (e.g., https://example.com)
            </div>
          </label>
        </div>

        <div class="form-group">
          <label class="label" for="refreshTime">
            <div class="label-text">Refresh Time (hours)</div>
            <input
              type="number"
              name="refreshTime"
              id="refreshTime"
              v-model="refreshTime"
              min="1"
              max="100"
            />
          </label>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';

  export default {
    name: 'CreateLinkWidgetModal',

    components: {
      Modal,
    },

    data() {
      return {
        name: 'URL Widget',
        refreshTime: 24,
        link: '',
        linkUsed: false,
      };
    },

    computed: {
      disableOkButton() {
        return this.name.length < 3 || !this.isValidUrl;
      },

      isValidUrl() {
        if (!this.link) return false;
        try {
          new URL(this.link);

          const urlPattern =
            /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

          return urlPattern.test(this.link);
        } catch (e) {
          return false;
        }
      },
    },

    methods: {
      createLinkWidget() {
        const data = {
          name: this.name,
          link: this.link,
          refreshTime: this.refreshTime || 0,
          timeUnit: 'hours',
        };

        this.$emit('createWidget', data);
        this.closeModal();
      },

      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .group-body {
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    margin-right: -16px;
    padding-right: 16px;

    .form-group {
      width: 100%;
      margin-bottom: 0px;
      max-width: 480px;

      label {
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
        font-weight: 500;
        line-height: 24px;

        input,
        select {
          padding: 8px 16px;
          border: 2px solid $borderGrey;
          border-radius: 8px;
          font-size: 16px;

          &.is-invalid {
            border-color: #dc3545;
          }
        }

        .label-text {
          margin-bottom: 8px;
        }

        .invalid-feedback {
          color: #dc3545;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
</style>
